import React from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import MapView from '../search/MapView';
import { useTranslation } from 'react-i18next';
import Loading from '../ui/Loading';
import { useSEO } from '../../custom hooks/useSEO';
const LocationPage = () => {
  const { t } = useTranslation();
  const { t: tSeo } = useTranslation("seo");

  const seo = useSEO({
    title: tSeo("placeMapView.title"),
    description: tSeo("placeMapView.description")
  });
  const { place, loading } = useSelector((state: RootState) => state.placeSlice);
  if (loading) return <Loading />
  return (
    <div className=' padding-container main-prop'>
      {seo}
      <h1 className="text-2xl font-semibold mb-4">{t("your-search-here")}</h1>
      <div className=' rounded-lg overflow-hidden'>
        <MapView places={place} />
      </div>

    </div>
  )
}

export default LocationPage